import { useResidentialById } from '@/entities/Residential'
import { getCurrentTranslation } from '@/shared/lib/utils'
import { navigationRoutes } from '@/shared/routes/navigationRoutes'
import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import { useLanguageStore } from '@/widgets/LanguageSelect/model/store'
import { ResidentialView } from '@/widgets/ResidentialView'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const ResidentialPage = () => {
  const { id } = useParams()
  const { data } = useResidentialById(Number(id))
  const { language } = useLanguageStore()
  const { t } = useTranslation()

  const routes = useMemo(
    () => [
      {
        path: navigationRoutes.projects,
        breadcrumb: t('breadcrumbs.projects'),
      },
      {
        path: `${navigationRoutes.residentialById(id || '')}`,
        breadcrumb: data && getCurrentTranslation(data, language, 'name'),
      },
    ],
    [id, data, language],
  )
  return (
    <>
      <BreadCrumbs breadCrumbs={routes} />
      <ResidentialView />
    </>
  )
}
